<template>
  <div>
    <Head :title="`${data.id}`"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/view`">
        {{ data.applicant_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/view`">{{data.treatment_type_name}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('interventions.logements') }}
    </h1>
    <div class="grid gap-4 lg:grid-cols-2 grid-cols-1">
      <detail-view :data="detailView">
        <template v-slot="item">
          <status-badge class="flex" v-if="item.props.key === 'status'" :status="item.props.value"/>
        </template>
      </detail-view>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import DetailView from '@/Shared/DetailView'
import StatusBadge from '@/Shared/StatusBadge'

export default {
  components: {
    DetailView,
    Head,
    Link,
    StatusBadge
  },
  layout: Layout,
  props: {
    data: Object,
  },
  data() {
    return {
      detailView: {
        items: [
          {key: 'status', label: this.$t('treatments.status'), value: this.data.status},
          {label: this.$t('treatmentlogements.status_actual'), value: this.data.status_actual_name},
          {label: this.$t('interventions.intervention_type'), value: this.data.type_name},
          {label: this.$t('treatmentlogements.date_start'), value: this.$filters.formatDate(this.data.date_start)},
          {label: this.$t('treatmentlogements.date_end'), value: this.$filters.formatDate(this.data.date_end)},
          {label: this.$t('treatmentlogements.notes'), value: this.data.notes},
        ],
        updateLink: `/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/treatment-logements/${this.data.id}/edit`,
        header: {
          title: 'Logement Information',
          text: 'Logement details and information.',
        },
      },
    }
  },
}
</script>
